import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'template/types', method: 'GET', token: token })
}
